// https://www.kunkalabs.com/mixitup/docs/get-started/
// import mixitup from 'mixitup';
// import mixitupMultifilter from '../../../plugins/mixitup/dist/mixitup-multifilter.js';
// mixitup.use(mixitupMultifilter);


$( document ).ready(function() {
    // mix it up - filter
    if ($('.mixit--filter').length) {
        var mixer = mixitup(".mixit--filter", {
            animation: {
                animateResizeTargets: true,
                duration: 550,
                nudge: true,
                reverseOut: false,
                effects: "fade scale(0.01) translateZ(-100px)"
            },
            multifilter: {
				enable: true, // enable the multifilter extension for the mixer
			},
            selectors: {
                control: '.mixitup-control'
            },
        });
    }
});
